import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportSportsResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportSportsInner() {
    return <PlayerLevelReportBase tab="sports" columnsSettingsViewType="PlayerLevelReportSports" />;
}

const PlayerLevelReportSportsWithAccess = withAccessCheck(PlayerLevelReportSportsInner, playerLevelReportSportsResource);

export const PlayerLevelReportSports = withTraceErrorBoundary(PlayerLevelReportSportsWithAccess, ErrorModal);
